// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BeforeApproving_qHd8v{
    embed{
        max-height: 90dvh;
         height: auto;
          width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Preview/SeeBill/SeeBill.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,iBAAiB;SAChB,YAAY;UACX,WAAW;IACjB;AACJ","sourcesContent":[".BeforeApproving{\n    embed{\n        max-height: 90dvh;\n         height: auto;\n          width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BeforeApproving": `BeforeApproving_qHd8v`
};
export default ___CSS_LOADER_EXPORT___;
